import { api, BACKEND_URL } from "./api";

export const athleteApi = {
  profile: () => api.get("/athlete/profile").then((r) => r.data),
  updateProfile: (payload) => api.patch("/athlete/profile", payload).then((r) => r.data),
  registrations: () => api.get("/athlete/registrations").then((r) => r.data),
  tournaments: () => api.get("/athlete/tournaments").then((r) => r.data),
  matches: () => api.get("/athlete/matches").then((r) => r.data),
  streak: () => api.get("/athlete/stats/streak").then((r) => r.data),
  // Phase 85.A.29 — Tự huỷ tham gia với OTP ZNS + reason.
  cancelRegistrationRequestOtp: (rid) =>
    api.post(`/athlete/registrations/${rid}/cancel/request-otp`).then((r) => r.data),
  cancelRegistrationConfirm: (rid, { otp_code, reason }) =>
    api
      .post(`/athlete/registrations/${rid}/cancel/confirm`, { otp_code, reason })
      .then((r) => r.data),
};

// Phase 83y.14 — Athlete sees + decides rating proposals from BTC.
export const athleteRatingProposals = {
  listPending: () => api.get("/athlete/rating-proposals").then((r) => r.data),
  decide: (proposalId, decision, disclaimerAck = true) =>
    api
      .patch(`/athlete/rating-proposals/${proposalId}`, {
        decision,                       // "accepted" | "rejected"
        disclaimer_ack: disclaimerAck,  // server requires true
      })
      .then((r) => r.data),
  // Phase 84.M.94 — VĐV đề xuất lại 1 điểm khác với admin gửi xuống.
  counter: (proposalId, counterScore, reason = "", disclaimerAck = true) =>
    api
      .post(`/athlete/rating-proposals/${proposalId}/counter`, {
        counter_score: Number(counterScore),
        reason: reason || null,
        disclaimer_ack: disclaimerAck,
      })
      .then((r) => r.data),
  // Phase 85.A.172 — Force-ack: VĐV đã counter rồi, admin chốt lại → VĐV phải nhận.
  forceAck: (proposalId) =>
    api
      .post(`/athlete/rating-proposals/${proposalId}/force-ack`)
      .then((r) => r.data),
};

export const adminRegistrationsApi = {
  setStatus: (id, status, rejectionReason = null) =>
    api.patch(`/admin/registrations/${id}`, { status, rejection_reason: rejectionReason }).then((r) => r.data),
  setPayment: (id, paymentStatus, paidAmountVnd, note) =>
    api.patch(`/admin/registrations/${id}/payment`, {
      payment_status: paymentStatus,
      paid_amount_vnd: paidAmountVnd,
      paid_note: note,
    }).then((r) => r.data),
  replacePlayer: (id, slot, { userId = null, externalName = null, otp = "" } = {}) =>
    api.patch(`/admin/registrations/${id}/replace-player`, {
      slot,
      ...(externalName ? { external_name: externalName } : { user_id: userId }),
      ...(otp ? { otp } : {}),
    }).then((r) => r.data),
  // Phase 85.A.291 — Sửa tên VĐV/đội free-text (import AI từ ảnh). Chỉ gửi field cần đổi.
  renameMembers: (id, fields) =>
    api.patch(`/admin/registrations/${id}/rename`, fields).then((r) => r.data),
  // Phase 83z.25 — Server-side bulk action endpoint.
  // action: "approve" | "reject" | "mark_paid"
  bulkAction: (ids, action, extra = {}) =>
    api.post("/admin/registrations/bulk-action", {
      ids,
      action,
      rejection_reason: extra.rejection_reason ?? null,
      reason_preset: extra.reason_preset ?? null,
      note: extra.note ?? null,
      paid_note: extra.paid_note ?? null,
      paid_amount_vnd: extra.paid_amount_vnd ?? null,
    }).then((r) => r.data),
  // Phase 88.E.57 — Bulk DELETE registrations.
  bulkDelete: (ids, otp = "") =>
    api.post("/admin/registrations/bulk-delete", { ids, ...(otp ? { otp } : {}) }).then((r) => r.data),
  // v21.35 — UNDO: khôi phục đăng ký vừa xoá (chỉ quanly1). Re-insert full doc.
  undoRestore: (ids) =>
    api.post("/admin/registrations/undo-restore", { ids }).then((r) => r.data),
};

// v17.10.cutover (Feb 2026) — `openMatchSocket()` helper đã xóa. Legacy
// endpoint `/api/ws/match/{id}` không còn tồn tại. Dùng `wsHub.subscribe(
// "match:{id}", handler)` từ `lib/wsHub.js` cho realtime match data.
